import {
  bugsnagStagesEnum,
  bugsnageInitProps,
  scopeType,
} from '@picsart/growth-rc/services/errorLogger';

import { API_URL, discordUrlPaths } from 'utils/endpoints';

import packageJson from '../../package.json';

const { version } = packageJson;

const goldBenefitURl = '/create';

//  special package names with custom buttun styles (see banner Content components)
export const packageIds = new Map([
  ['discord_nitro_tial', true],
  ['theskimm_1', true],
  ['flickr_1', true],
  ['samsung', true],
  ['ru_1', true],
]);

// pages which will need to redirect after sign in on mobile
export const redirectOnMobile = new Map([['home', true]]);

// special package names which have to check the user is gold or not and redirect to unique link
// The key property is screenName and the value is the unique path which have to return the unique link
// [screenName, getUniqueLinkPostPath]
export const nitroPartnerships = new Map([['discord_nitro_tial', discordUrlPaths]]);

// the special partnerships pages which have to redirect after subscribtion <[screenName, redirectionURL]>
export const checkWithRedirectionPL = new Map([
  ['pinterest_creator_offer', goldBenefitURl],
  ['picsartpro_trial', goldBenefitURl],
  ['aliexpress_trial', goldBenefitURl],
  ['shutterfly_trial', goldBenefitURl],
  ['tps_engage_trial', goldBenefitURl],
  ['pinterest_trial', goldBenefitURl],
  ['flickr_trial', goldBenefitURl],
  ['amaze_trial', goldBenefitURl],
  ['usweekly', goldBenefitURl],
  ['fb_ad_v2', goldBenefitURl],
  ['smugmug_trial', goldBenefitURl],
]);

// for monetization custom screens name
const customScreenName = new Map<string, string>([['fbwb', 'fb_ad_v2']]);

const customWelcomePopups = new Map([['fb_ad_v2', true]]);

export const customPageOpenEvents = new Map([['fb_ad_page_open', { source: 'true' }]]);

// some partnerships pages category property is marketing and that time needs to disable autoplay feature in header
export const checkMarketingPartnerships = new Map([['fb_ad_v2', true]]);

export const analyticModule = 'landings';

// ----------------------------check functions----------------------------

export const getWithRedirectionPL = screenName => checkWithRedirectionPL.get(screenName);

export const getRedirectOnMobile = (screenName: string): boolean =>
  !!redirectOnMobile.get(screenName);

export const checkPackage = (packageName: string): boolean => !!packageIds.get(packageName);

export const getNitroPackageUrl = (screenName: string): string | undefined =>
  nitroPartnerships.get(screenName);

export const checkSpecialMarketingPage = screenName => checkMarketingPartnerships.has(screenName);

export const apiUrl = API_URL;

export const adyenKey = process.env.REACT_APP_PUBLIC_ADYEN_KEY;

export const isCustomWelcomePL = screenName => customWelcomePopups.has(screenName);

export const getCustomScreenName = (screenName: string) => customScreenName.get(screenName);

export const errorLoggerConfig: bugsnageInitProps = {
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  releaseStage: bugsnagStagesEnum[process.env.REACT_APP_BUGSNAG_ENV],
  appVersion: version,
  scope: scopeType.growth,
  project: 'landings',
};

export enum TierPlans {
  PRO = 'pro',
  PLUS = 'plus',
  GOLD = 'gold_old',
  FREE = 'free',
}

export const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const activePageMeasurers = {
  'background-remover': {
    id: 'background-remover-upload-measurer',
    action: 'image-upload-speed',
    scope: 'background-remover',
  },
};

export enum PremiumPackages {
  discordNitro = 'discord-nitro',
  customApiFlow = 'custom_API_flow',
}

export const CTA_TEXT = 'monetization-button-text';
export const GTM_EXPERIMENT_URLS = ['ai-background-ad', 'logo-maker-ad'];
export const INDEXED_SEARCH_PATH = 's';
